import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconExpandMoreSvg } from "./IconExpandMoreSvg.mjs";
const IconExpandMore = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconExpandMoreSvg, ...iconProps });
};
export {
  IconExpandMore
};
